export default __webpack_public_path__ + "static/media/electrolysis.de5ea9f3.svg";